module.exports = __webpack_public_path__ + "static/media/no-products.cd3e93bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-products.svg
// module id = 2335
// module chunks = 0